import P from "react";
import { cls as C } from "../../helpers/cls.js";
import { forwardAsTagRef as T } from "../../helpers/forwardAsTagRef.js";
import { spacingReplace as o } from "../../helpers/spacingReplace.js";
var W = Object.defineProperty,
  $ = Object.defineProperties,
  F = Object.getOwnPropertyDescriptors,
  l = Object.getOwnPropertySymbols,
  g = Object.prototype.hasOwnProperty,
  x = Object.prototype.propertyIsEnumerable,
  c = (r, a, t) => a in r ? W(r, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[a] = t,
  s = (r, a) => {
    for (var t in a || (a = {})) g.call(a, t) && c(r, t, a[t]);
    if (l) for (var t of l(a)) x.call(a, t) && c(r, t, a[t]);
    return r;
  },
  G = (r, a) => $(r, F(a)),
  V = (r, a) => {
    var t = {};
    for (var e in r) g.call(r, e) && a.indexOf(e) < 0 && (t[e] = r[e]);
    if (r != null && l) for (var e of l(r)) a.indexOf(e) < 0 && x.call(r, e) && (t[e] = r[e]);
    return t;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const u = T((r, a) => {
  const t = r,
    {
      tag: e,
      children: _,
      margin: O,
      marginLeft: w,
      marginBottom: y,
      marginTop: b,
      marginRight: v,
      padding: D,
      paddingLeft: R,
      paddingBottom: E,
      paddingTop: j,
      paddingRight: S,
      flex: n,
      alignItems: i,
      flexDirection: p,
      justifyContent: m,
      flexWrap: f,
      customDataDsComponent: d,
      gap: h,
      columnGap: B,
      rowGap: I
    } = t,
    L = V(t, ["tag", "children", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight", "padding", "paddingLeft", "paddingBottom", "paddingTop", "paddingRight", "flex", "alignItems", "flexDirection", "justifyContent", "flexWrap", "customDataDsComponent", "gap", "columnGap", "rowGap"]),
    N = e != null ? e : "div";
  return P.createElement(N, s(G(s({
    "data-ds-component": d != null ? d : "DS-Flex"
  }, L), {
    ref: a,
    className: C(r.className, "olx-d-flex", o("olx-m", O), o("olx-ml", w), o("olx-mb", y), o("olx-mt", b), o("olx-mr", v), o("olx-p", D), o("olx-pl", R), o("olx-pb", E), o("olx-pt", j), o("olx-pr", S), i && "olx-ai-".concat(i), p && "olx-fd-".concat(p), m && "olx-jc-".concat(m), f && "olx-fw-".concat(f), n && "olx-flex", o("olx-gap", h), o("olx-cg", B), o("olx-rg", I))
  }), n && {
    style: {
      "--olx-flex": n
    }
  }), _);
});
u.displayName = "Flex";
export { u as Flex };